.header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.footer {
  display: flex;
  gap: 12px;
  justify-content: end;
}
.smallInput {
  width: 102px;
}
.boxOption {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  font-weight: var(--font-weight-strong);
}
.createBox {
  color: var(--color-primary);
}
.placeholder {
  width: 0;
  overflow: hidden;
  flex: 1;
  text-overflow: ellipsis;
}
